(function() {
  'use strict';

  angular.module('app.config')
    .factory('appConfig', appConfig);

  function appConfig($rootScope, $q, esriLoader) {
    let config;
    let appConfigService = {
      setConfig: setConfig,
      getConfig: getConfig,
      getAdminWebMapData: getAdminWebMapData
    };

    return appConfigService;

    //////////// functions

    function setConfig(theConfig) {
      config = theConfig;
    }

    function getConfig() {
      return config;
    }

    function getAdminWebMapData() {
      let d = $q.defer();
      esriLoader.require([
        'esri/request'
      ], function(
        esriRequest
      ) {
        // console.log('get web map data');
        let requestHandle = esriRequest({
          'url': 'https://www.arcgis.com/sharing/rest/content/items/' + config.adminWebMapId + '/data',
          'content': {
            'f': 'json'
          },
          'handeAs': 'json',
          'callbackParamName': 'callback'
        });
        requestHandle.then(function(results) {
          // set the feature service url's first
          for (let i = 0; i < results.operationalLayers.length; i++) {
            let layer = results.operationalLayers[i];
            if (layer.title === config.parcelsEditing) {
              config.parcelsUrl = layer.url;
            } else if (layer.title === config.tractsEditing) {
              config.tractsUrl = layer.url;
            }
          }
          // next set the table urls
          for (let i = 0; i < results.tables.length; i++) {
            let table = results.tables[i];
            if (table.title === config.timberAssets) {
              config.timberAssetsUrl = table.url;
            } else if (table.title === config.tractsHistory) {
              config.tractsHistoryUrl = table.url;
            }
          }
          d.resolve(config);
        }, function(err) {
          console.error(err);
        });
      });
      return d.promise;
    }
  }
}());